var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemWarningFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 3c.712 0 1.424.332 1.793.997l7.993 14.393c.666 1.199-.303 2.61-1.793 2.61H4.007c-1.49 0-2.459-1.411-1.793-2.61l7.993-14.393C10.577 3.332 11.288 3 12 3m0 12A1 1 0 1 0 12 16.998 1 1 0 0 0 12 15m0-6c-.553 0-1 .559-1 1.25v2.5c0 .691.447 1.25 1 1.25s1-.559 1-1.25v-2.5C13 9.559 12.553 9 12 9",
  clipRule: "evenodd"
})));
export default SvgGemWarningFilled;